var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProPlanWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99609 14.501C6.99609 15.0536 7.444 15.5015 7.99651 15.5015H15.9998C16.5524 15.5015 17.0003 15.0536 17.0003 14.501",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99609 14.501V9.53185C6.99609 9.34738 7.09764 9.17788 7.26029 9.09085C7.42293 9.00381 7.62028 9.01335 7.77377 9.11567L9.99734 10.598L11.582 8.22104C11.6748 8.08188 11.831 7.99829 11.9982 7.99829C12.1655 7.99829 12.3216 8.08188 12.4144 8.22104L13.999 10.598L16.2226 9.11565C16.3761 9.01333 16.5734 9.00379 16.7361 9.09083C16.8987 9.17787 17.0003 9.34737 17.0003 9.53185V14.501",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9998,
    cy: 12,
    r: 9.00375,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProPlanWhite);
export default __webpack_public_path__ + "static/media/proPlanWhite.2abfd56ba79f4004e0763783769bc65f.svg";
export { ForwardRef as ReactComponent };